import { Grid } from '@material-ui/core';
import { connect, Field } from 'formik';
import { EChargeType } from 'interfaces/IEditProduct';
import React, { Fragment } from 'react';
import createShowIf from 'v2/components/Shared/createShowIf';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SwitchFormField } from 'v2/components/Shared/FormFields/SwitchFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { Payments, Subscription } from 'v2/components/Pages/Product/Edit/classes/Payment';
import type { IForm } from 'v2/components/Shared/Content';

import { commissionTypes, ECommissionType } from '../../classes/Product';
import { useEditProduct } from '../../context';

import type { Affiliation as AffiliationClass } from '../../classes/Affiliates';

interface IProps extends IForm<AffiliationClass> {}

const Affiliation = (props: IProps) => {
  const { values, initialValues } = props.formik;
  const { setFocus } = props;
  const { paymentType } = useEditProduct();

  const ShowIfPayment = createShowIf<Payments | Subscription>();
  const ShowIfAffiliation = createShowIf<AffiliationClass>();

  const funnelCommissionTypes = [
    {
      label: 'Meia Comissão',
      value: 50,
    },
    {
      label: 'Comissão Inteira',
      value: 100,
    },
  ];

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field onFocus={setFocus} label='Deixar visível na vitrine' id='visible' name='visible' component={SwitchFormField} />
        </Grid>
        <Grid item xs={12}>
          <Field label='Afiliação automática' id='auto_affiliation' name='auto_affiliation' component={SwitchFormField} />
        </Grid>
        <ShowIfPayment value={paymentType} compare={{ eq: { charge_type: EChargeType.SUBSCRIPTION } }}>
          <Grid item xs={12}>
            <Field
              label='Tipo de comissão recorrente'
              id='recurring_comission_type'
              name='recurring_comission_type'
              options={commissionTypes}
              component={SelectFormField}
              disabled={values.recurring_comission_type === ECommissionType.PERCENTAGE}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              label='Valor da comissão recorrente'
              id='recurring_comission_value'
              mask={values.recurring_comission_type === ECommissionType.PERCENTAGE ? 'percent' : 'money'}
              name='recurring_comission_value'
              component={TextFormField}
            />
          </Grid>
        </ShowIfPayment>
        <ShowIfPayment
          value={paymentType}
          compare={{
            diff: [{ charge_type: EChargeType.FREE }, { charge_type: EChargeType.SUBSCRIPTION, membership_fee: false }],
          }}
        >
          <Grid item xs={12}>
            <Field
              label={paymentType.charge_type === EChargeType.SUBSCRIPTION ? 'Tipo da comissão de adesão' : ' Tipo da comissão'}
              id='comission_type'
              name='comission_type'
              options={paymentType.charge_type === EChargeType.OTHER ? [commissionTypes[0]] : commissionTypes}
              component={SelectFormField}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              label={paymentType.charge_type === EChargeType.SUBSCRIPTION ? 'Valor da comissão de adesão' : ' Valor da comissão'}
              id='comission_value'
              mask={values.comission_type === ECommissionType.PERCENTAGE ? 'percent' : 'money'}
              name='comission_value'
              component={TextFormField}
            />
          </Grid>
        </ShowIfPayment>
        <Grid item xs={12}>
          <Field
            disabled={initialValues.infinity_funnel}
            label='Funil Infinito'
            id='infinity_funnel'
            name='infinity_funnel'
            component={SwitchFormField}
          />
        </Grid>
        <ShowIfAffiliation value={values} compare={{ eq: { infinity_funnel: true } }}>
          <Grid item xs={12}>
            <Field
              label='Comissão de funil'
              id='funnel_commission'
              name='funnel_commission'
              options={funnelCommissionTypes}
              component={SelectFormField}
              disabled={!values.infinity_funnel}
            />
          </Grid>
        </ShowIfAffiliation>
      </Grid>
    </Fragment>
  );
};

export default connect(Affiliation);
